import {mergeSx} from '@hconnect/uikit/src/lib2'
import {BoxProps, Box} from '@mui/material'
import React from 'react'

interface PlannerIconProps extends Pick<BoxProps, 'sx'> {
  icon: React.ReactNode
}

export const PlannerIcon: React.FC<PlannerIconProps> = ({icon, sx: otherSx}) => {
  return (
    <Box
      sx={mergeSx(
        ({spacing, palette}) => ({
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          p: 1,
          fontSize: spacing(2),
          width: spacing(4),
          height: spacing(4),
          fill: palette.text.primary
        }),
        otherSx
      )}
    >
      {icon}
    </Box>
  )
}
